import * as yup from "yup";

export const EditRoleSchema = yup.object({
  roleName: yup.string()
    .min(2, "Role name must be two or more characters")
    .max(255, "Role name must be less than or equal to 255 characters"),
  description: yup.string()
    .min(2, "Description must be two or more characters")
    .max(255, "Description must be less than or equal to 255 characters"),
});
